module.exports = __webpack_public_path__ + "static/media/elevator.21513762.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-iconic/svg/elevator.svg
// module id = 59
// module chunks = 0